import { LOGIN_PATH, OIDC_CALLBACK_PATH } from "@airange/shared/oidc-routes";
import { getBrowserBaseName, isAppLocalPathname, toAppLocalPathname, toBrowserPath } from "./public-path";

function normalizePathname(pathname: string) {
  const normalized = String(pathname || "/").split(/[?#]/, 1)[0] || "/";
  return normalized.startsWith("/") ? normalized : `/${normalized}`;
}

function readBrowserPathname() {
  if (typeof window === "undefined") {
    return "/";
  }
  return window.location.pathname || "/";
}

export function resolveAdminAppPublicPath() {
  const browserBaseName = getBrowserBaseName();
  const baseName = browserBaseName === "/" ? "" : browserBaseName;
  return baseName;
}

export function normalizeAdminInternalRoutePath(browserPathname: string) {
  return toAppLocalPathname(normalizePathname(browserPathname));
}

export function buildAdminAppPath(routePath: string, searchParams?: URLSearchParams | string) {
  const normalizedRoutePath = normalizePathname(routePath);
  const query = searchParams instanceof URLSearchParams
    ? searchParams.toString()
    : String(searchParams || "").replace(/^\?/, "");
  const path = toBrowserPath(normalizedRoutePath);
  return query ? `${path}?${query}` : path;
}

export function buildAdminLoginPath(searchParams?: URLSearchParams | string) {
  return buildAdminAppPath(LOGIN_PATH, searchParams);
}

export function resolveAdminInternalPathname(pathname: string) {
  return normalizeAdminInternalRoutePath(pathname);
}

export function isAdminAuthBrowserPath(pathname: string, routePath: string) {
  return isAppLocalPathname(pathname, routePath);
}

export function canonicalizeAdminBrowserLocation() {
  if (typeof window === "undefined") {
    return null;
  }

  const pathname = normalizePathname(window.location.pathname || "/");
  const search = window.location.search || "";
  const hash = window.location.hash || "";
  const canonicalPath = buildAdminAppPath(resolveAdminInternalPathname(pathname), search);
  const currentUrl = `${pathname}${search}${hash}`;
  const canonicalUrl = `${canonicalPath}${hash}`;

  if (canonicalUrl === currentUrl) {
    return null;
  }

  window.history.replaceState(window.history.state, "", canonicalUrl);
  return canonicalUrl;
}
